import Admin from "../Layout/Admin";
import About from "../Pages/About/About";
import Contact from "../Pages/Contact/Contact";
import Home from "../Pages/Home/Home";
import Portfolio from "../Pages/Portfolio/Portfolio";
import PortfolioDetails from "../Pages/Portfolio/PortfolioDetails";
import Resume from "../Pages/Resume/Resume/Resume";
import Comming from "../Pages/Shared/Comming";
import NotFound from "../Pages/Shared/NotFound";

const { createBrowserRouter } = require("react-router-dom");
const { default: MainLayout } = require("../Layout/MainLayout");

const routes = createBrowserRouter([
    {
        path:'/',
        element:<MainLayout/>,
        children:[
            {
                path:'*',
                element:<NotFound/>
            },
            {
                path:'/',
                element:<Home/>
            },
            {
                path:'/about',
                element:<About/>
            },
            {
                path:'/resume',
                
                element:<Resume/>
            },
            {
                path:'/contact',
                element: <Contact/>

              },
            {
                path:'/portfolio',
                
                element:<Portfolio/>
            },
            {
                path:'/portfolio/:id',
               loader:({params})=> fetch(`https://personal-portfolio-server-lovat.vercel.app/portfolio/${params.id}`),
                element:<PortfolioDetails/>
            }
            ,{
                path:'/blogs',
                element:<Comming/>
            }
        ],
       
    },
    {
        path:'/cpanel',
        element:<Admin/>
    }
])

export default routes